/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Back Icon component.
 */
export const MaterialBackIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialBackIcon' size={iconSize} color={iconColor} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
        <path d='M24.8667 13.8667L23 12L15 20L23 28L24.8667 26.1333L18.7333 20L24.8667 13.8667Z'
          fill={iconColor}
          fillRule='evenodd'
          clipRule='evenodd' />
      </svg>
    )} />
  );
};

MaterialBackIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey1
};

export default MaterialBackIcon;
